import React, { useState } from 'react';
import Select from 'react-select';
import { stockService } from '../services/stockService';
import { useLanguage } from '../contexts/LanguageContext';
import { Search } from 'lucide-react';

const StockSearch = ({ onStockSelect }) => {
  const { t } = useLanguage();
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const loadOptions = async (inputValue) => {
    if (inputValue.length < 2) {
      setOptions([]);
      return;
    }

    setIsLoading(true);
    try {
      const results = await stockService.searchStocks(inputValue);
      const formattedOptions = results.map(stock => ({
        value: stock.symbol,
        label: `${stock.symbol} - ${stock.name}`,
        data: stock
      }));
      setOptions(formattedOptions);
    } catch (error) {
      console.error('Search failed:', error);
      setOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    if (newValue && newValue.length >= 2) {
      // Clear existing timeout
      if (window.searchTimeout) {
        clearTimeout(window.searchTimeout);
      }
      // Set new timeout
      window.searchTimeout = setTimeout(() => {
        loadOptions(newValue);
      }, 500);
    } else {
      setOptions([]);
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      onStockSelect(selectedOption.data);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '48px',
      border: '2px solid #e2e8f0',
      borderRadius: '8px',
      '&:hover': {
        border: '2px solid #3b82f6'
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f1f5f9' : 'white',
      color: state.isSelected ? 'white' : '#1f2937'
    })
  };

  return (
    <div className="card">
      <div className="stock-search">
        <label>
          <Search size={16} style={{marginRight: '0.5rem'}} />
          {t('searchStocks')}
        </label>
        <Select
          inputValue={inputValue}
          onInputChange={handleInputChange}
          options={options}
          onChange={handleChange}
          isLoading={isLoading}
          placeholder={t('searchPlaceholder')}
          noOptionsMessage={() => 
            inputValue.length < 2 
              ? t('searchPlaceholder')
              : t('noResults')
          }
          styles={customStyles}
          isClearable
          isSearchable
        />
      </div>
    </div>
  );
};

export default StockSearch;